import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import ErrorImg from '../../../assets/errors/cloud.png';

export function AccessDenied() {
    return (
         <Fragment>
                <div className="d-flex flex-column align-items-center justify-content-center vh-100">
                    <img src={ErrorImg} alt="Error" style={{ maxWidth: 300 }} />
                    <p>403: You do not have access to this resource.</p>
                    <Link className="text-primary" to="/">Main Page</Link>
                </div>
         </Fragment>
     );
}
